{
  "pt_BR": "estacionamento",
  "cs_CZ": "parkoviste",
  "da_DK": "parkering",
  "de_DE": "parkplatz",
  "en_GB": "parking",
  "es_ES": "aparcamiento",
  "fi_FI": "pysaekoeinti",
  "fr_FR": "parking",
  "it_IT": "parcheggio",
  "ja_JP": "chushajo",
  "ko_KR": "juchajang",
  "nl_NL": "parkeren",
  "nb_NO": "parkering",
  "pl_PL": "parking",
  "pt_PT": "estacionamento",
  "ru_RU": "parkovka",
  "sv_SE": "parkering",
  "tr_TR": "otopark",
  "zh_CN": "ting-chewei"
}
